import AutomationImg from "../assests/img/robotic-arms-modern-factory-setting.jpg";
import caseImg from "../assests/img/casestudy.svg";
import shopImg from "../assests/img/shopping.svg";
import healthcareImg from "../assests/img/health.svg";
import epriseImg from "../assests/img/store.svg";
import agriImg from "../assests/img/scooter.svg";
import allImg from "../assests/img/social.svg";

const blogImages = {
  AutomationImg,
};

const caseStudyImages = {
  fintech: caseImg,
  retail: shopImg,
  healthcare: healthcareImg,
  enterprise: epriseImg,
  agriculture: agriImg,
  social: allImg,
};

export const getBlogImage = (item, fallback = AutomationImg) => {
  if (!item) {
    return fallback;
  }

  if (item.image?.startsWith("http") || item.image?.startsWith("/")) {
    return item.image;
  }

  if (item.img && blogImages[item.img]) {
    return blogImages[item.img];
  }

  return fallback;
};

export const getCaseStudyImage = (titleOrKey, fallback = caseImg) => {
  const key = String(titleOrKey || "")
    .toLowerCase()
    .replace(/\s+/g, "");

  return caseStudyImages[key] || fallback;
};
